exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-form-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;row-gap:16px;width:100%}.booking-form-named-step{padding-top:20px;padding-bottom:20px}.booking-form-group-shading{background-color:#f8f6f2}.booking-form-group-shading .simple-textfield,.booking-form-group-shading .booking-address-field,.booking-form-group-shading .MuiIconButton-label,.booking-form-group-shading .phone-number-group{background-color:#fff}\n", ""]);

// exports
